import apiContact from '~/api/contact';
import apiCotizacion from '~/api/cotizacion';

export default (ctx, inject) => {
  inject('api', {
    /*contact: apiContact(ctx.$axios, ctx.$config.websiteContactApiURL),
    cotizacion: apiCotizacion(ctx.$axios, ctx.$config.cotizacionApiURL)*/
  })
}
